import { Switch, SwitchProps, styled } from '@mui/material'
import dashedLine from '../images/dashed-curved-switch-to-table-line-mobile.svg'

const CustomSwitch = styled((props: SwitchProps) => (
  <Switch focusVisibleClassName=".Mui-focusVisible" disableRipple {...props} />
))(({ theme }) => ({
  width: 76,
  height: 42,
  padding: 0,
  border: `1px solid #e9e7e1`,
  borderRadius: 21,
  '& .MuiSwitch-switchBase': {
    padding: 0,
    margin: 7,
    transitionDuration: '300ms',
    '&.Mui-checked': {
      transform: 'translateX(16px)',
      color: '#fff',
      paddingLeft: 16,
      '& + .MuiSwitch-track': {
        backgroundColor: '#222222',
        opacity: 1,
        border: 0,
      },
      '&.Mui-disabled + .MuiSwitch-track': {
        opacity: 0.5,
      },
    },
    '&.Mui-focusVisible .MuiSwitch-thumb': {
      color: '#e9e7e1',
      border: '6px solid #e9e7e1',
    },
    '&.Mui-disabled .MuiSwitch-thumb': {
      color: '#e9e7e1',
    },
    '&.Mui-disabled + .MuiSwitch-track': {
      opacity: 0.7,
    },
  },
  '& .MuiSwitch-thumb': {
    boxSizing: 'border-box',
    width: 28,
    height: 28,
    color: '#e9e7e1',
  },
  '& .MuiSwitch-track': {
    backgroundColor: '#222222',
    opacity: 1,
    transition: theme.transitions.create(['background-color'], {
      duration: 500,
    }),
    width: '100%',
  },
}))

const MobileScreen4 = () => {
  return (
    <div
      className="flex flex-col items-center gap-6 w-[146px] absolute text-left"
      style={{
        left: `calc(50% - 146px)`,
        bottom: `${80}px`,
      }}
    >
      <p className="text-orange font-decimal text-[22px]">
        Switch to table view
      </p>
      <img src={dashedLine} alt="dashed line" />
      <div
        className="fixed bottom-0 left-0 justify-center items-center h-[80px] w-full"
        id="screen4-container"
      >
        <div className="border-r-[1px] border-none flex p-4 justify-center items-center h-full">
          <CustomSwitch />
        </div>
      </div>
    </div>
  )
}
export default MobileScreen4
